<!-- Center canvas: summary, text typed into directly - whole card is one pinnable region -->
<div class="cr-res-card" *ngIf="isPreview" [id]="block.blockId">
  <span class="cr-res-badge">Reservation, contact + address</span>

  <!-- Fixed section label, not an editable field - matches the mockup's own
       hardcoded "Your accommodation" heading (see the component comment). -->
  <p class="cr-res-heading">Your accommodation</p>

  <div class="cr-res-grid">
    <div
      class="cr-res-dropzone"
      [appInlineMedia]="block.variables?.['Res1Image']"
      [inlineMediaBlockId]="block.blockId"
      (inlineMediaChange)="onChange($event, 'Res1Image')"
    >
      <a *ngIf="block.variables?.['Res1Image']; else empty1" [href]="image1Href" target="_blank" rel="noopener">
        <img [src]="block.variables?.['Res1Image']" [alt]="block.variables?.['Res1ImageAlt'] || ''" />
      </a>

      <ng-template #empty1>
        <div class="cr-inline-media-icon">
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
            <path d="M12 19.2V11.7" />
            <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
          </svg>
        </div>
        <div class="cr-inline-media-title">Upload image</div>
        <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
      </ng-template>
    </div>

    <div
      class="cr-res-dropzone"
      [appInlineMedia]="block.variables?.['Res2Image']"
      [inlineMediaBlockId]="block.blockId"
      (inlineMediaChange)="onChange($event, 'Res2Image')"
    >
      <a *ngIf="block.variables?.['Res2Image']; else empty2" [href]="image2Href" target="_blank" rel="noopener">
        <img [src]="block.variables?.['Res2Image']" [alt]="block.variables?.['Res2ImageAlt'] || ''" />
      </a>

      <ng-template #empty2>
        <div class="cr-inline-media-icon">
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
            <path d="M12 19.2V11.7" />
            <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
          </svg>
        </div>
        <div class="cr-inline-media-title">Upload image</div>
        <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
      </ng-template>
    </div>
  </div>

  <span
    class="cr-res-name"
    [appInlineEdit]="block.variables?.ResPropertyName ?? ''"
    [inlineEditBlockId]="block.blockId"
    inlineEditPlaceholder="Insert property name"
    (inlineEditChange)="onChange($event, 'ResPropertyName')"
  ></span>

  <div class="cr-res-details">
    <p class="cr-res-detail-line">
      <span class="cr-res-detail-label">Address:</span>
      <span
        class="cr-res-detail-value"
        [appInlineEdit]="block.variables?.ResAddress ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert address"
        (inlineEditChange)="onChange($event, 'ResAddress')"
      ></span>
    </p>
    <p class="cr-res-detail-line">
      <span class="cr-res-detail-label">Telephone:</span>
      <span
        class="cr-res-detail-value"
        [appInlineEdit]="block.variables?.ResTelephone ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert telephone number"
        (inlineEditChange)="onChange($event, 'ResTelephone')"
      ></span>
    </p>
    <div class="cr-res-times">
      <p class="cr-res-detail-line">
        <span class="cr-res-detail-label">Check-In:</span>
        <span
          class="cr-res-detail-value"
          [appInlineEdit]="block.variables?.ResCheckIn ?? ''"
          [inlineEditBlockId]="block.blockId"
          inlineEditPlaceholder="--:--"
          (inlineEditChange)="onChange($event, 'ResCheckIn')"
        ></span>
      </p>
      <p class="cr-res-detail-line">
        <span class="cr-res-detail-label">Check-Out:</span>
        <span
          class="cr-res-detail-value"
          [appInlineEdit]="block.variables?.ResCheckOut ?? ''"
          [inlineEditBlockId]="block.blockId"
          inlineEditPlaceholder="--:--"
          (inlineEditChange)="onChange($event, 'ResCheckOut')"
        ></span>
      </p>
    </div>
  </div>
</div>

<!-- Right panel: real edit form - two identical image field groups, then property/contact fields -->
<div class="cr-res-edit" *ngIf="!isPreview">
  <div class="cr-res-edit-card">
    <div class="cr-res-edit-card-title">First Image</div>

    <div class="cr-res-field-row">
      <span class="cr-res-field-label">Image</span>
      <span
        class="cr-res-toggle"
        [class.cr-res-toggle-on]="image1AsUpload"
        role="button"
        tabindex="0"
        [title]="image1AsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
        (click)="toggleImage1Mode()"
        (keydown.enter)="toggleImage1Mode()"
        (keydown.space)="toggleImage1Mode()"
      ></span>
    </div>
    <div class="cr-res-image-field">
      <app-block-text
        [maxLength]="500"
        type="link"
        [blockData]="block.variables?.['Res1Image'] ?? ''"
        (handleOnChange)="onChange($event, 'Res1Image')"
        [placeholder]="image1Placeholder"
        variable="Res1Image"
        [isImage]="image1AsUpload"
        [isPlainText]="true"
        [blockId]="block.blockId"
      ></app-block-text>
      <div class="cr-res-empty-overlay" *ngIf="image1AsUpload && !block.variables?.['Res1Image']">
        <div class="cr-res-icon">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
            <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
            <path d="M12 19.2V11.7" />
            <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
          </svg>
        </div>
        <div class="cr-res-title">Upload image</div>
        <div class="cr-res-subtitle">PNG up to 2 mb</div>
      </div>
    </div>

    <div class="cr-res-link-field">
      <app-field-editor-v2
        [maxLength]="500"
        type="action-link"
        [blockData]="block.variables?.['Res1ImageHref'] ?? ''"
        (handleOnChange)="onChange($event, 'Res1ImageHref')"
        [placeholder]="image1HrefPlaceholder"
        variable="Res1ImageHref"
        (handleOnSegmentChange)="handleOnSegmentChange($event, 'Res1ImageHrefSegmentRegex')"
        [selectedSegment]="block.variables?.['Res1ImageHrefSegmentRegex'] ?? ''"
        [disabled]="disabled"
      ></app-field-editor-v2>
    </div>

    <app-field-editor-v2
      type="alt"
      [blockData]="block.variables?.['Res1ImageAlt'] ?? ''"
      (handleOnChange)="onChange($event, 'Res1ImageAlt')"
      [placeholder]="image1AltPlaceholder"
      [maxLength]="500"
      variable="Res1ImageAlt"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <div class="cr-res-edit-card">
    <div class="cr-res-edit-card-title">Second Image</div>

    <div class="cr-res-field-row">
      <span class="cr-res-field-label">Image</span>
      <span
        class="cr-res-toggle"
        [class.cr-res-toggle-on]="image2AsUpload"
        role="button"
        tabindex="0"
        [title]="image2AsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
        (click)="toggleImage2Mode()"
        (keydown.enter)="toggleImage2Mode()"
        (keydown.space)="toggleImage2Mode()"
      ></span>
    </div>
    <div class="cr-res-image-field">
      <app-block-text
        [maxLength]="500"
        type="link"
        [blockData]="block.variables?.['Res2Image'] ?? ''"
        (handleOnChange)="onChange($event, 'Res2Image')"
        [placeholder]="image2Placeholder"
        variable="Res2Image"
        [isImage]="image2AsUpload"
        [isPlainText]="true"
        [blockId]="block.blockId"
      ></app-block-text>
      <div class="cr-res-empty-overlay" *ngIf="image2AsUpload && !block.variables?.['Res2Image']">
        <div class="cr-res-icon">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
            <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
            <path d="M12 19.2V11.7" />
            <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
          </svg>
        </div>
        <div class="cr-res-title">Upload image</div>
        <div class="cr-res-subtitle">PNG up to 2 mb</div>
      </div>
    </div>

    <div class="cr-res-link-field">
      <app-field-editor-v2
        [maxLength]="500"
        type="action-link"
        [blockData]="block.variables?.['Res2ImageHref'] ?? ''"
        (handleOnChange)="onChange($event, 'Res2ImageHref')"
        [placeholder]="image2HrefPlaceholder"
        variable="Res2ImageHref"
        (handleOnSegmentChange)="handleOnSegmentChange($event, 'Res2ImageHrefSegmentRegex')"
        [selectedSegment]="block.variables?.['Res2ImageHrefSegmentRegex'] ?? ''"
        [disabled]="disabled"
      ></app-field-editor-v2>
    </div>

    <app-field-editor-v2
      type="alt"
      [blockData]="block.variables?.['Res2ImageAlt'] ?? ''"
      (handleOnChange)="onChange($event, 'Res2ImageAlt')"
      [placeholder]="image2AltPlaceholder"
      [maxLength]="500"
      variable="Res2ImageAlt"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <div class="cr-res-edit-card">
    <div class="cr-res-edit-card-title">Details</div>

    <app-field-editor-v2
      type="content"
      [blockData]="block.variables?.['ResPropertyName'] ?? ''"
      (handleOnChange)="onChange($event, 'ResPropertyName')"
      [placeholder]="namePlaceholder"
      [maxLength]="500"
      variable="ResPropertyName"
      [disabled]="disabled"
    ></app-field-editor-v2>

    <app-field-editor-v2
      type="content"
      [blockData]="block.variables?.['ResAddress'] ?? ''"
      (handleOnChange)="onChange($event, 'ResAddress')"
      [placeholder]="addressPlaceholder"
      [maxLength]="500"
      variable="ResAddress"
      [disabled]="disabled"
    ></app-field-editor-v2>

    <app-field-editor-v2
      type="content"
      [blockData]="block.variables?.['ResTelephone'] ?? ''"
      (handleOnChange)="onChange($event, 'ResTelephone')"
      [placeholder]="telephonePlaceholder"
      [maxLength]="500"
      variable="ResTelephone"
      [disabled]="disabled"
    ></app-field-editor-v2>

    <div class="cr-res-times-fields">
      <app-field-editor-v2
        type="content"
        [blockData]="block.variables?.['ResCheckIn'] ?? ''"
        (handleOnChange)="onChange($event, 'ResCheckIn')"
        [placeholder]="checkInPlaceholder"
        [maxLength]="25"
        variable="ResCheckIn"
        [disabled]="disabled"
      ></app-field-editor-v2>

      <app-field-editor-v2
        type="content"
        [blockData]="block.variables?.['ResCheckOut'] ?? ''"
        (handleOnChange)="onChange($event, 'ResCheckOut')"
        [placeholder]="checkOutPlaceholder"
        [maxLength]="25"
        variable="ResCheckOut"
        [disabled]="disabled"
      ></app-field-editor-v2>
    </div>
  </div>
</div>
